import axios from 'axios';

import axiosWithHeaders from '@/lib/axios-instance';
import { APIUrlGenerator } from '@/lib/helper';

import { PostFeedbackType } from '@/components/app/demo/services/type';
import { GetProductType } from '@/components/app/product/services/type';

import { API_ROUTES } from '@/constant/routes';
import BundleModel from '@/models/bundle.model';
import ProductModel from '@/models/product.model';

export async function getProductDemo(slug: GetProductType = '') {
  const {
    data: { payload },
  }: { data: { payload: ProductModel | BundleModel } } = await axios.get(
    APIUrlGenerator(API_ROUTES.GET_SINGLE_PRODUCT(slug)),
  );
  return payload;
}

export async function postFeedback(body: PostFeedbackType) {
  const { data } = await axiosWithHeaders.post(
    APIUrlGenerator(API_ROUTES.POST_FEEDBACK),
    body,
  );
  return data;
}
